import { koComponent } from '../../../../ko-utils';
import $api from '../../../../api';
import initializeCharts from './charts';
import { prepareSerializedDateRange, serializeDateRange } from '../../../../utils/dateRanges';
import DetailsView from './detailsView';

class AdoptionMeterView {
    constructor(params) {
        DetailsView();

        this.isVisibleKo = params.isVisible;
        this.isVisibleKo.subscribe(val => {
            this.reinitIfVisible();
        });

        this.features = ko.observableArray();

        this.globalDateRange = ko.observableArray(prepareSerializedDateRange('adoption_daterangepicker_saved'));
        this.globalDateRange.subscribe(val => {
            serializeDateRange('adoption_daterangepicker_saved', val);
            this.reinitIfVisible();
        });

        this.selectedFeatures = ko.observableArray();

        this.noData = ko.observable(true);

        this.chartTypes = [
            { text: 'Features ratings', value: 'overview' },
            { text: 'Ratings on timeline', value: 'timeline' },
        ];

        let preselectedChartType = localStorage.getItem('insights_preselected_charttype');
        if (!preselectedChartType) preselectedChartType = 'overview';
        this.selectedChartType = ko.observable(preselectedChartType);
        this.selectedChartType.subscribe((val) => {
            localStorage.setItem('insights_preselected_charttype', val);
            this.requestMoodsChart();
        });

        this.detailMoodsCat = ko.observable();

        this.reinitIfVisible();
    }

    get isVisible() {
        return ko.unwrap(this.isVisibleKo);
    }

    reinitIfVisible() {
        if (this.isVisible && !this.wasInit) {
            this.onInit();

            this.wasInit = true;
        } else {
            this.requestIfVisible();
        }
    }

    requestIfVisible() {
        if (this.isVisible) {
            this.requestMoodsChart();
        }
    }

    onInit() {
        $api.insights.initializeMoods(
            { projectCode: auth.project.UniqueCode },
            {},
            (resp) => {
                this.features(resp.activeTags);
                this.selectedFeatures(this.preselectedTags);

                this.requestMoodsChart();
            }
        );

        this.selectedFeatures.subscribe((val) => {
            $api.users.setSettings(
                {},
                { key: 'insights_preselected_tags', value: val },
                () => { }
            );

            this.requestMoodsChart();
        });

        initializeCharts();
    }

    requestMoodsChart() {
        if (this.selectedChartType() == 'overview') this.requestMoodsOverview();
        if (this.selectedChartType() == 'timeline') this.requestMoodsOnTimeline();
    }

    requestMoodsOverview() {
        $api.insights.getMoodsOverview(
            { projectCode: auth.project.UniqueCode },
            { from: this.globalDateRange()[0], to: this.globalDateRange()[1], tags: this.selectedFeatures() },
            (resp) => {
                if (resp.every(i => i.tagsSumCount == 0)) {
                    this.noData(true);
                } else {
                    this.noData(false);
                    document.dispatchEvent(new CustomEvent('refresh_chart_overview', {
                        detail: resp
                    }))
                }
            }
        );
    }

    requestMoodsOnTimeline() {
        $api.insights.getMoodsOnTimeline(
            { projectCode: auth.project.UniqueCode },
            { from: this.globalDateRange()[0], to: this.globalDateRange()[1], tags: this.selectedFeatures() },
            (resp) => {
                if (resp.every(i => i.tagsSumCount == 0)) {
                    this.noData(true);
                } else {
                    this.noData(false);
                    document.dispatchEvent(new CustomEvent('refresh_chart_timeline', {
                        detail: resp
                    }))
                }
            }
        );
    }

    showDetailMoods(cat) {
        document.body.classList.add('fullscreen-overlay-shown');
        this.detailMoodsCat(cat);
    }

    closeDetail() {
        document.body.classList.remove('fullscreen-overlay-shown');
        this.detailMoodsCat(null);
    }
}

export default koComponent('adoption-meter-view', AdoptionMeterView);